import { render } from "./Outages.vue?vue&type=template&id=7868247b&lang=pug"
import script from "./Outages.vue?vue&type=script&lang=js"
export * from "./Outages.vue?vue&type=script&lang=js"

import exportComponent from "/home/apognu/code/personal/defcon/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__